export const gatedContentRootId = 'gated-content-root';
export const blogContentId = 'blog-main-content';
